module.exports = __webpack_public_path__ + "img/1079.44f527d6.svg";